import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import ListingAPI from '../../../axios/listing';
// the dialog shares the look of the message dialog
import '../../search-page/search-page.css';

// a few common reasons, everything else is "other" with a description; each must be one of
// REPORT_REASONS on the server, which still knows the older ones for reports made before
const REASONS = ['fake', 'sold', 'wrong_info', 'other'];

export const ReportModal = ({ listing, onClose }) => {
    const { t } = useTranslation(["details"]);
    const [reason, setReason] = useState(null);
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    // null, 'error' or 'throttled'
    const [error, setError] = useState(null);

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    // "other" says nothing on its own, so it needs an explanation
    const canSend = reason !== null && (reason !== 'other' || message.trim().length > 0) && !sending;

    const send = () => {
        if (!canSend) return;
        setSending(true);
        setError(null);
        // text typed under "other" and then left for another reason is not sent
        ListingAPI.reportListing(listing.id, { reason, message: reason === 'other' ? message : '' })
            .then(() => setSent(true))
            .catch(err => setError(err.response?.status === 429 ? 'throttled' : 'error'))
            .finally(() => setSending(false));
    };

    return (
        <div className='hs-msg-overlay' onClick={onClose}>
            <div className='hs-msg' role='dialog' aria-label={t('report_title')} onClick={(e) => e.stopPropagation()}>
                {sent ?
                    <div className='hs-msg-sent'>
                        <span className='hs-msg-sent-icon'>
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>
                        </span>
                        <h2>{t('report_sent_title')}</h2>
                        <p>{t('report_sent_text')}</p>
                        <button onClick={onClose}>{t('close')}</button>
                    </div>
                    :
                    <>
                        <div className='hs-msg-head'>
                            <h2>{t('report_title')}</h2>
                            <button className='hs-msg-x' onClick={onClose} aria-label={t('close')}>×</button>
                        </div>
                        <div className='hs-msg-to'>
                            <span className='hs-report-listing'>{listing.title}</span>
                            <span className='hs-msg-id'>{t('listing_no', { id: listing.id })}</span>
                        </div>
                        <div className='hs-msg-fields'>
                            <div className='hs-report-reasons' role='radiogroup' aria-label={t('report_reason')}>
                                {REASONS.map(key => (
                                    <label key={key} className={`hs-report-reason ${reason === key ? 'on' : ''}`}>
                                        <input type='radio' name='report-reason' checked={reason === key} onChange={() => setReason(key)} />
                                        {t(`report_reason_${key}`)}
                                    </label>
                                ))}
                            </div>
                            {reason === 'other' &&
                                <label className='hs-msg-field'>
                                    <span>{t('report_message_required')}</span>
                                    <textarea rows={3} value={message} maxLength={2000} autoFocus placeholder={t('report_message_placeholder')}
                                        onChange={(e) => setMessage(e.target.value)} />
                                </label>}
                            {error && <p className='hs-msg-error'>{t(error === 'throttled' ? 'report_throttled' : 'report_error')}</p>}
                        </div>
                        <div className='hs-msg-actions'>
                            <button className='hs-msg-cancel' onClick={onClose}>{t('cancel')}</button>
                            <button className='hs-msg-send' disabled={!canSend} onClick={send}>{t('report_send')}</button>
                        </div>
                    </>}
            </div>
        </div>
    );
};
